import { useNavigate } from "react-router-dom";

export default function EmptyProducts({ emptyproduct }) {
    const navigate = useNavigate();
    return (<div className="empty-product">
        <img
            src={emptyproduct}
            alt="Empty cart"
            className="empty-cart-image"
        />
        <p className="empty-cart-subtitle">
            We couldn't find a match, but there's more waiting to be discovered.
        </p>
        <button
            className="empty-cart-btn"
            onClick={() => navigate("/")} //  send user back to home/shop
        >
            EXPLORE &nbsp;
        </button>
    </div>
    );
}
